module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.59462636.ttf";